import React from 'react';
import PropTypes from 'prop-types';

export default function GlobalStyles(props) {
  const {
    settings,
    containerCssClass,
  } = props;
  const cssContainer = containerCssClass || settings.containerCssSelector || '';
  const styles = `
    ${cssContainer} .snapgadget-btn{
      background: ${settings.darkColor};
      color: ${settings.buttonColor};
    }
    ${cssContainer} a.snapgadget-btn{
      background: ${settings.darkColor};
      color: ${settings.buttonColor};
      display: inline-block;
    }
    ${cssContainer} .snapgadget-btn:hover, ${cssContainer} a.snapgadget-btn:hover{
      background-color: ${settings.lightColor} !important;
    }
  `;
  return (
    <style dangerouslySetInnerHTML={{ __html: styles }} />
  );
}

GlobalStyles.propTypes = {
  settings: PropTypes.shape({
    darkColor: PropTypes.string,
    buttonColor: PropTypes.string,
    lightColor: PropTypes.string,
    containerCssSelector: PropTypes.string,
  }).isRequired,
  containerCssClass: PropTypes.string,
};

GlobalStyles.defaultProps = {
  containerCssClass: '',
};
